import React, { useState } from 'react'

const getFormattedContent = (content: string): string => {
  try {
    const parsed = JSON.parse(content ?? '')
    return JSON.stringify(parsed, null, 2)
  } catch (error) {
    return content
  }
}

export const ExpandableContent: React.FC<{ content: string }> = ({ content }) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const formattedContent = getFormattedContent(content)

  // Estimate if content needs truncation (rough estimation based on character count and newlines)
  const shouldTruncate = content.length > 400 || (content.match(/\n/g) || []).length > 6

  const getNewLineBreaks = (value: string): string => {
    return value.trim().replace(/\n/g, '<br />').replace(/\\"/g, '"')
  }
  if (!shouldTruncate) {
    return (
      <div className="text-xs text-gray-800 bg-slate-50 p-2 border border-slate-200 wrap-break-word">
        <p
          className="break-all"
          dangerouslySetInnerHTML={{
            __html: getNewLineBreaks(formattedContent)
          }}
        />
      </div>
    )
  }

  return (
    <div className="text-xs text-gray-800 bg-slate-50 p-2 border border-slate-200 wrap-break-word">
      <p
        className={`${!isExpanded ? 'line-clamp-6 overflow-hidden break-all' : 'break-all'}`}
        dangerouslySetInnerHTML={{
          __html: getNewLineBreaks(formattedContent)
        }}
      />
      <div className="flex justify-end">
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="mt-2 text-blue-600 hover:text-blue-800 text-xs font-base underline focus:outline-none"
        >
          {isExpanded ? 'View less' : 'View more'}
        </button>
      </div>
    </div>
  )
}
